<template>
  <div class="face-match">
    <parametrs-list :items.sync="fieldsData.parameters" :parameters="fieldsData.properties"> </parametrs-list>
    <b-field class="apply">
      <edit-button :editOptions="['Apply']" @click="apply()">
        <template>
          <span class="text">{{ $t('button.apply') }}</span>
        </template>
      </edit-button>
    </b-field>
  </div>
</template>
<script>
import EditButton from '@/components/EditButton'
import ParametrsList from '@/components/ParametrsList'

export default {
  name: 'DashboardFaceMatch',
  components: {
    ParametrsList,
    EditButton
  },
  props: {
    items: {
      type: Object,
      default() {
        return {}
      }
    },
    configs: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      fieldsData: {}
    }
  },
  mounted() {
    this.rerender()
    this.$forceUpdate()
  },
  watch: {
    configs: {
      deep: true,
      immediate: true,
      handler: 'rerender'
    }
  },
  methods: {
    rerender() {
      const parameters = {}
      for (const [key, value] of Object.entries(this.items.parameters)) {
        parameters[key] = value
      }
      const properties = []
      for (const item of this.items.properties) {
        properties.push(item)
      }
      this.fieldsData = {
        parameters,
        properties
      }

    },
    apply() {
      this.$emit('apply', { parameters: this.fieldsData.parameters })
    }
  }
}
</script>

<style lang="scss">
.face-match {
  display: flex;
  flex-direction: column;
  padding: 0;
  width: 100%;
  height: 100%;
  .parametrs-list {
    margin-bottom: 0.75rem;
    min-width: auto;
    img {
      max-height: 200px;
    }
    .field {
      .field-body {
        flex-grow: 5;
      }
      .field-label {
        // min-width: 8rem;
        padding-top: 0;
        width: 100%;
        .label {
          text-align: right;
          width: 100%;
          // min-width: 6.25rem;
        }
      }
    }
  }
  .apply {
    justify-content: right;
    display: flex;
  }
}
</style>
